import Vue from 'vue'

import withRender from './badge.html'
import './badge.scss'

export default withRender(Vue.extend({
  props: { type: String },
  computed: {
    typeClass() {
      return this.type ? `tt-o-badge--${this.type}` : ''
    }
  }
}))
